import React from "react";
import "./Button.scss";
export type color = "mfg-primary" | "mfg-secondary" | "mfg-success" | "mfg-danger" | "mfg-plain";

export interface Props {
  ButtonClass?: color;
  ButtonId?: any;
  children: any;
  onClick?: any;
  link?: any;
  customClass?: any;
  tabIndex?: number;
  role?: string;
  ariaSelected?: boolean;
  target?: any;
  ariaControl?: string;
  disabled?: boolean;
}

const Button = ({
  ButtonClass = "mfg-primary",
  ButtonId,
  children,
  onClick,
  link,
  customClass,
  tabIndex,
  role,
  ariaSelected,
  target,
  ariaControl,
  disabled
}: Props) => {
  return (
    <>
      {link ? (
        <a
          href={link}
          className={`mfg-btn mfg-btn-link${customClass ? " " + customClass : ""}`}
          id={ButtonId}
          onClick={onClick}
          target={target}
        >
          {children}
        </a>
      ) : (
        <button
            aria-selected={ariaSelected}
            role={role}
            className={`mfg-btn${ButtonClass ? " " + ButtonClass : ""}${customClass ? " " + customClass : ""
              }`}
            id={ButtonId}
            onClick={onClick}
            tabIndex={tabIndex}
            aria-controls={ariaControl}
            disabled={disabled}
        >
          {children}
        </button>
      )}
    </>
  );
};

export default Button;
